import React from 'react';
import { PopupOrPanel } from '../../components/popupsAndPanels/PopupAndPanels';

type Props = {
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onContinue: any;
};

export const SubscriptionDoubleSubDiscountOverrideModal: React.FC<Props> = ({
  panelOpen,
  togglePanelOpen,
  onContinue,
}) => {
  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={panelOpen}
      hdrTitle={'Good News!'}
      position="right"
      primaryBtnTxt="Continue"
      givenClass="SubscriptionDoubleSubDiscountModal"
      primaryBtnColor="BtnOrange"
      handleClose={() => togglePanelOpen(false)}
      handlePrimaryBtn={() => onContinue()}
      width={560}
    >
      <p>You’re already getting our best value with the double subject discount, your promo code is not valid on this order.</p>
    </PopupOrPanel>
  );
};
